<template>
  <div
    class="v_all_background"
    id="con_lf_top_div"
    :style="{
      'padding-left': paddingW + 'rem',
      'padding-right': paddingW + 'rem',
      'padding-top': paddingH + 'rem',
      'padding-bottom': paddingH + 'rem',
    }"
    @mousemove="mouseMove()"
  >

    <div class="v_video_all">
      <video
        id="video"
        ref="video"
        width="100%"
        class="v_video"
        @timeupdate="videoTimeUpdate()"
        @canplay="videoCanPlay()"
        loop
      ></video>
      <div class="online_video_bg" v-if="isOnline">
        <img class="photo" :src="onlineVideoData.coverUrl" alt="">
        <img class="border" :src="onlineVideoData.coverBorderUrl" alt="">
        <img class="name" :src="onlineVideoData.nameBase64" alt="">
      </div>
      <!-- autoplay -->
      <!-- 背景音乐 -->
      <audio id="audio" ref="audio" loop></audio>
    </div>

    <div
      class="v_bottom_none"
      v-if="noVideo"
      :style="{
        'padding-bottom': paddingH + 'rem',
        transform: 'scale(' + wangSize + ')',
      }"
    >
      <!-- left: paddingW + 'px',
        right: paddingW + 'px', 
      @click="aaaaa"-->
      <div class="v_bottom_none_middle">
        <div class="v_bottom_left">
          <div
            class="v_bottom_text"
            style="margin-left: 6rem; margin-right: 2rem"
          >
            弹幕使用
          </div>
          <img
            src="@/assets/images/video/iv_message_open.png"
            alt=""
            class="iv_message"
            v-if="isOpen"
            @click="toOpenMessage"
          />
          <img
            src="@/assets/images/video/iv_message_close.png"
            alt=""
            class="iv_message"
            v-if="!isOpen"
            @click="toOpenMessage"
          />
          <div
            class="v_bottom_text"
            style="margin-left: 4rem; margin-right: 2rem"
          >
            播放文件
          </div>
          <div class="v_chocie_all" @click="choiceVideo">
            <img
              src="@/assets/images/video/iv_button.png"
              alt=""
              class="iv_button"
            />
            <div class="v_choice_text">选择</div>
          </div>

          <div class="v_chocie_video_online" @click="chooseVideoOnline">
            <div class="v_choice_text_online">直火遗像</div>
          </div>

          <input
            type="file"
            id="chooseFile"
            ref="chooseFile"
            @change="chooseLocaleFile($event)"
            class="v_input"
          />
        </div>
        <img
          src="@/assets/images/video/iv_close.png"
          alt=""
          class="iv_close"
          @click="closePage"
        />
      </div>
    </div>

    <div
      class="v_bottom_click_line"
      @mouseover="toShow()"
      v-if="!noVideo"
      :style="{
        bottom: paddingH + 'rem',
        left: paddingW + 'rem',
        right: paddingW + 'rem',
      }"
    ></div>

    <div
      class="v_bottom_ani"
      @mouseleave="tohide()"
      v-if="toShowAni"
      :style="{
        'padding-bottom': paddingH + 'rem',
        transform: 'scale(' + wangSize + ')',
      }"
    >
      <!-- height: 23 + paddingH + 'rem', -->
      <!-- left: paddingW + 'px',
        right: paddingW + 'px', 
      @click="aaaaa"-->
      <div class="v_bottom_none_another">
        <div class="v_bottom_left">
          <div
            class="v_bottom_text"
            style="margin-left: 6rem; margin-right: 2rem"
          >
            弹幕使用
          </div>
          <img
            src="@/assets/images/video/iv_message_open.png"
            alt=""
            class="iv_message"
            v-if="isOpen"
            @click="toOpenMessage"
          />
          <img
            src="@/assets/images/video/iv_message_close.png"
            alt=""
            class="iv_message"
            v-if="!isOpen"
            @click="toOpenMessage"
          />
          <div
            class="v_bottom_text"
            style="margin-left: 4rem; margin-right: 2rem"
          >
            播放文件
          </div>
          <div class="v_chocie_all" @click="choiceVideoA">
            <img
              src="@/assets/images/video/iv_button.png"
              alt=""
              class="iv_button"
            />
            <div class="v_choice_text">选择</div>
          </div>
          <input
            type="file"
            id="chooseFilea"
            ref="chooseFilea"
            @change="chooseLocaleFileA($event)"
            class="v_input"
          />
          <div class="v_chocie_video_online" @click="chooseVideoOnline">
            <div class="v_choice_text_online">直火遗像</div>
          </div>
          <div
            class="v_bottom_text"
            style="margin-left: 4rem; margin-right: 2rem"
          >
            视频缩放
          </div>
          <div class="progress_item">
            <img
              class="progress_item_text"
              src="@/assets/images/video/iv_size_cut.png"
              alt=""
              @click="toCut"
            />
            <el-slider
              class="progress_item_slider"
              v-model="wangPic"
              :max="100"
              @change="changePic"
            ></el-slider>
            <img
              class="progress_item_text"
              src="@/assets/images/video/iv_size_add.png"
              alt=""
              @click="toAdd"
            />
            <img
              src="@/assets/images/video/iv_full_screen_yes.png"
              alt=""
              class="progress_item_text"
              v-if="!isAll"
              @click="toAll"
              style="margin-left: 2rem"
            />
            <img
              src="@/assets/images/video/iv_full_screen_no.png"
              alt=""
              class="progress_item_text"
              v-if="isAll"
              @click="toAll"
              style="margin-left: 2rem"
            />
          </div>
        </div>
        <img
          src="@/assets/images/video/iv_close.png"
          alt=""
          class="iv_close"
          @click="closePage"
        />
      </div>

      <div class="progress">
        <img
          src="@/assets/images/video/iv_pause.png"
          alt=""
          class="progress_button"
          v-if="isPlay"
          @click="toPlay"
        />
        <img
          src="@/assets/images/video/iv_play.png"
          alt=""
          class="progress_button"
          v-if="!isPlay"
          @click="toPlay"
        />
        <el-slider
          v-model="wangTime"
          :max="wangTimeAll"
          :show-tooltip="false"
          @change="changeTime"
          @input="inputTime"
        ></el-slider>
        <img
          src="@/assets/images/video/sound_open.png"
          alt=""
          class="iv_sound"
          v-if="isSound"
          @click="toSound"
        />
        <img
          src="@/assets/images/video/sound_close.png"
          alt=""
          class="iv_sound"
          v-if="!isSound"
          @click="toSound"
        />
      </div>
    </div>

    <div
      class="barrages-drop"
      :style="{
        top: paddingH + 'rem',
        left: paddingW + 'rem',
        right: paddingW + 'rem',
      }"
    >
      <div v-show="isOpen">
        <div class="barrages_item" id="divText1"></div>
        <div class="barrages_item" id="divText2"></div>
      </div>
      <div>
        <div id="hiddenText1" class="barrages_text" style="display: none">
          <div class="barrages_text_item">
            <img class="v_message_item_img" />
            <span class="v_message_item_img_only"></span>
            <span class="v_message_item_msg_a"></span>
            <span class="v_message_item_name"></span>
            <!-- <span class="v_message_item_relation"></span> -->
            <span class="v_message_item_msg"></span>
          </div>
        </div>
        <div id="hiddenText2" class="barrages_text" style="display: none">
          <div class="barrages_text_item">
            <img class="v_message_item_img" />
            <span class="v_message_item_img_only"></span>
            <span class="v_message_item_msg_a"></span>
            <span class="v_message_item_name"></span>
            <!-- <span class="v_message_item_relation"></span> -->
            <span class="v_message_item_msg"></span>
          </div>
        </div>
      </div>
      <div ref="barragesItem" style="width: 100%; height: 1rem"></div>
    </div>
  </div>
</template>
<script>
import screenfull from "screenfull";
import $ from "jquery";
import { perspnalLink } from "@/utils/utils";
import mixin from "./Mixins";

export default {
  mixins: [mixin],
  data() {
    return {
      vcTotalTime: "",
      vcCurrentTime: "",

      number: 0,
      wangTime: 0,
      wangTimeAll: 0,

      noVideo: true,
      toShowAni: false,

      wangPic: 100,
      paddingW: 0,
      paddingH: 0,
      isOpen: true,
      isPlay: false,
      isOnline:false,
      onlineVideoData:{},

      websock: null,
      messageData: [],

      isTop: true,
      screenWidth: "",
      screenHeight: "",
      userNameNew: "",
      msgNew: "",
      isChocie: false,
      isSound: true,

      isClose: false,
      //是否全屏
      isAll: false,
      heartCheck: null,
      moveTimeOut: null,
      wangSize: 1,
      //历史弹幕定时任务
      bulletScreenTimer : null,
      bulletScreenTimerMillisecond : 6000,
    };
  },
  created() {},
  computed: {},
  mounted() {
    this.screenWidth = window.screen.width;
    this.screenHeight = window.screen.height;
    if (window.localStorage.getItem("wangPic") != null) {
      this.wangPic = parseInt(window.localStorage.getItem("wangPic"));
      this.wangSize =
        (this.screenWidth - (100 - this.wangPic)).toFixed(2) / this.screenWidth;
      this.paddingW = (100 - this.wangPic) * 0.1;
      this.paddingH =
        ((100 - this.wangPic) / this.screenWidth) * this.screenHeight * 0.1;
    }
    this.initWebSocket();
    window.addEventListener("keydown", this.KeyDown, true); // 监听按键事件
    window.addEventListener("popstate", this.onClickLeft, false);
    //心跳检测
    let that = this;
    var heartCheck = {
      timeout: 3000, //每隔三秒发送心跳
      severTimeout: 5000, //服务端超时时间
      timeoutObj: null,
      serverTimeoutObj: null,
      start: function () {
        var _this = this;
        this.timeoutObj && clearTimeout(this.timeoutObj);
        this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj);
        this.timeoutObj = setTimeout(function () {
          //这里发送一个心跳，后端收到后，返回一个心跳消息，
          //onmessage拿到返回的心跳就说明连接正常
          that.websock.send("PING"); // 心跳包
          //计算答复的超时时间
          _this.serverTimeoutObj = setTimeout(function () {
            console.log("心跳检测到超时");
            that.websock.close();
          }, _this.severTimeout);
        }, this.timeout);
      },
    };
    that.heartCheck = heartCheck;
    heartCheck = null;

    window.onresize = () => {
      console.log(!this.checkFull());
      if (!this.checkFull()) {
        // 全屏下按键esc后要执行的动作
        this.isAll = false;
      }
    };
    //获取历史弹幕
    this.findBulletScreenByDmId();
  },
  methods: {
    checkFull() {
      // 判断浏览器是否处于全屏状态 （需要考虑兼容问题）
      var isFull =
        document.mozFullScreen ||
        document.fullScreen ||
        document.webkitIsFullScreen ||
        document.webkitRequestFullScreen ||
        document.mozRequestFullScreen ||
        document.msFullscreenEnabled;
      if (isFull === undefined) {
        isFull = false;
      }
      return isFull;
    },
    onClickLeft() {
      this.isClose = true;
      this.heartCheck = null;
      this.websock.close();
    },
    KeyDown(event) {
      if (event.keyCode === 122) {
        //禁用f11
        event.returnValue = false;
        //触发全屏的按钮
        if (this.isAll) {
          this.isAll = false;
          screenfull.exit();
        } else {
          this.isAll = true;
          screenfull.toggle();
        }
      }
    },
    choiceVideo() {
      this.$refs.chooseFile.dispatchEvent(new MouseEvent("click"));
    },
    choiceVideoA() {
      this.isChocie = true;
      this.$refs.chooseFilea.dispatchEvent(new MouseEvent("click"));
    },
    chooseLocaleFile(file) {
      let files = document.getElementById("chooseFile").files[0];
      const isMp4 = files.type == "video/mp4";
      if (!isMp4) {
        this.$message.error("请使用mp4格式的文件");
        return false;
      }
      let url = window.webkitURL.createObjectURL(files);
      this.$refs.video.src = url;
      this.$refs.audio.src = "";
      this.noVideo = false;
      this.isPlay = false;
      this.isOnline = false;
    },
    chooseLocaleFileA(file) {
      let files = document.getElementById("chooseFilea").files[0];
      const isMp4 = files.type == "video/mp4";
      if (!isMp4) {
        this.$message.error("请使用mp4格式的文件");
        return false;
      }
      let url = window.webkitURL.createObjectURL(files);
      this.$refs.video.src = url;
      this.$refs.audio.src = "";
      this.noVideo = false;
      this.isPlay = false;
      this.isOnline = false;
      let a = document.getElementById("chooseFilea");
      a.value = "";
    },
    chooseVideoOnline() {
      let dmId = this.$route.query.id;

      let params = dmId;
      const loading = this.$loading({
        lock: true,
        text: "正在生成视频",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
        this.getCoverVideo(
          params
        ).then((res) => {
          loading.close();
          console.log(res);
          if (res.status == 1000) {
            var onlineData = res.data;
            this.$refs.video.src = onlineData.coverVideoBgUrl;
            this.$refs.audio.src = onlineData.coverAudioBgUrl;
            this.onlineVideoData = onlineData;
            this.noVideo = false;
            this.isPlay = false;
            this.isOnline = true;
          } else if(res.status == 1008) {
            // 操作频繁
          }
        });
    },
    //  获取总时长
    videoCanPlay() {
      var duration = this.$refs.video.duration;
      this.wangTimeAll = this.$refs.video.duration;
      //this.toShowAni = false;
      //this.isChocie = false;
      //this.vcTotalTime = this.getFormatVideoTime(duration);
    },
    //  更新进度时间
    videoTimeUpdate() {
      this.wangTime = this.$refs.video.currentTime;
    },

    changeTime(val) {
      console.log("change" + val);
      this.$refs.video.currentTime = val;
    },

    inputTime(val) {
      if (parseInt(this.$refs.video.currentTime) != parseInt(val)) {
        this.$refs.video.currentTime = val;
      }
    },

    toShow() {
      this.toShowAni = true;
    },

    tohide() {
      console.log("hide");
      if (!this.isChocie) {
        this.toShowAni = false;
      } else {
        this.isChocie = false;
      }
    },

    changePic(val) {
      this.paddingW = (100 - val) * 0.1;
      console.log(this.screenWidth);
      console.log(this.screenHeight);
      this.paddingH =
        ((100 - val) / this.screenWidth) * this.screenHeight * 0.1;
      console.log(this.paddingW);
      this.wangPic = val;
      this.wangSize =
        (this.screenWidth - (100 - val)).toFixed(2) / this.screenWidth;
      window.localStorage.setItem("wangPic", val);
    },

    //开弹幕
    toOpenMessage() {
      if (this.isOpen) {
        this.isOpen = false;
        this.websock.send("CLOSE");
      } else {
        //document.getElementById("divText1").innerHTML = "";
        //document.getElementById("divText2").innerHTML = "";
        this.isOpen = true;
        this.websock.send("OPEN");
      }
    },

    toPlay() {
      if (!this.isPlay) {
        this.isPlay = true;
        this.$refs.video.play();
        this.$refs.audio.play();
      } else {
        this.isPlay = false;
        this.$refs.video.pause();
        this.$refs.audio.pause();
      }
    },

    /**
     * 建立socket连接，调用时间：
     * 1.首次进入页面，如果不是查看记录，请求出来初始数据后，建立socket连接
     * 2.调用数据库查询完毕后
     * */
    initWebSocket() {
      let adminId = window.localStorage.getItem("zgjs_login_id");
      let dmId = this.$route.query.id;
      //初始化weosocket
      const wsuri = `${perspnalLink()}/socket/websocket/deadman/${adminId}/${dmId}`;
      this.websock = new WebSocket(wsuri);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },

    websocketonopen() {
      //连接建立之后执行send方法发送数据
      console.log("成功");
      this.websock.send("OPEN");
      this.heartCheck.start();
      this.isClose = false;
    },

    /**
     * 连接建立失败,断开连接
     * 1.查询一次数据库数据
     * 2.查询完后再次建立socket连接
     * */
    websocketonerror() {
      //连接建立失败重连
      console.log("连接建立失败");
      this.isClose = true;
      setTimeout(() => {
        this.initWebSocket();
      }, 5000);
    },

    // aaaaa(){
    //   //'photo':'https://zgsm.zhongguangshimei.com/test/user/photo/uph_1657865870000452166_.png',
    //   let item = {};
    //   let data = {'content':'永垂千古，功业长存','dmId':1127,'nickname':'莱斯利',
      
    //   'relation':'亲属','type':2}

    //   item.userName = data.nickname;
    //   item.avatar = data.photo;
    //   item.relation = data.relation;
    //   if (data.type == 1) {
    //     item.msg = '送上寄语：'+data.content;
    //   } else {
    //     item.msg = "献了一束花";
    //   }

    //   if (this.isTop) {
    //     if(data.type == 1){
    //       $("#hiddenText1 .v_message_item_img_only").show();
    //       $("#hiddenText1 .v_message_item_img_only").html(item.userName.substring(0,1));
    //       $("#hiddenText1 .v_message_item_img").hide();
    //       $("#hiddenText1 .v_message_item_msg_a").show();
    //       $("#hiddenText1 .v_message_item_msg_a").html(item.relation);
    //     }else{
    //       if(data.photo != undefined && data.photo != ''){
    //         $("#hiddenText1 .v_message_item_img_only").hide();
    //         $("#hiddenText1 .v_message_item_img").show();
    //         $("#hiddenText1 .v_message_item_img").attr("src", item.avatar);
    //         $("#hiddenText1 .v_message_item_msg_a").hide();
    //       }else{
    //         $("#hiddenText1 .v_message_item_img_only").show();
    //         $("#hiddenText1 .v_message_item_img_only").html(item.userName.substring(0,1));
    //         $("#hiddenText1 .v_message_item_img").hide();
    //         $("#hiddenText1 .v_message_item_msg_a").hide();
    //       }
    //     }
    //     $("#hiddenText1 .v_message_item_name").html(item.userName);
    //     $("#hiddenText1 .v_message_item_msg").html(item.msg);
    //     var obj1 = $($("#hiddenText1").html());
    //     obj1.attr("class", "spanText");
    //     let a = parseFloat($("#hiddenText1").css("width"));
    //     obj1.css("right", a * -1);
    //     obj1.css("width", a);
    //     $("#divText1").append(obj1);
    //     this.startText(obj1);
    //     this.isTop = false;
    //   } else {
    //     if(data.type == 1){
    //       $("#hiddenText2 .v_message_item_img_only").show();
    //       $("#hiddenText2 .v_message_item_img_only").html(item.userName.substring(0,1));
    //       $("#hiddenText2 .v_message_item_img").hide();
    //       $("#hiddenText2 .v_message_item_msg_a").show();
    //       $("#hiddenText2 .v_message_item_msg_a").html(item.relation);
    //     }else{
    //       if(data.photo != undefined && data.photo != ''){
    //         $("#hiddenText2 .v_message_item_img_only").hide();
    //         $("#hiddenText2 .v_message_item_img").show();
    //         $("#hiddenText2 .v_message_item_img").attr("src", item.avatar);
    //         $("#hiddenText2 .v_message_item_msg_a").hide();
    //       }else{
    //         $("#hiddenText2 .v_message_item_img_only").show();
    //         $("#hiddenText2 .v_message_item_img_only").html(item.userName.substring(0,1));
    //         $("#hiddenText2 .v_message_item_img").hide();
    //         $("#hiddenText2 .v_message_item_msg_a").hide();
    //       }
    //     }
    //     $("#hiddenText2 .v_message_item_name").html(item.userName);
    //     $("#hiddenText2 .v_message_item_msg").html(item.msg);
    //     var obj1 = $($("#hiddenText2").html());
    //     obj1.attr("class", "spanText");
    //     let a = parseFloat($("#hiddenText2").css("width"));
    //     obj1.css("right", a * -1);
    //     obj1.css("width", a);
    //     $("#divText2").append(obj1);
    //     this.startText(obj1);
    //     this.isTop = true;
    //   }
    // },

    websocketonmessage(e) {
      
      //数据接收
      //console.log(e);
      this.heartCheck.start();
      if (e.data == "PONG") {
        return;
      }
      if (e.data == "CLOSE") {
        this.isClose = true;
        return;
      }
      let that = this;
      if (e.data == "DM_ERROR") {
        this.isClose = true;
        this.websock.close();
        return;
      }
      if (!this.isOpen) {
        return;
      }
      this.appendDivText(JSON.parse(e.data));
    },
    appendDivText(data) {
      let item = {};
      item.userName = data.nickname;
      item.avatar = data.photo;
      item.relation = data.relation;
      if (data.type == 1) {
        item.msg = '送上寄语：'+data.content;
      } else {
        item.msg = "献了一束花";
      }

      if (this.isTop) {
        if(data.type == 1){
          $("#hiddenText1 .v_message_item_img_only").show();
          $("#hiddenText1 .v_message_item_img_only").html(item.userName.substring(0,1));
          $("#hiddenText1 .v_message_item_img").hide();
          $("#hiddenText1 .v_message_item_msg_a").show();
          $("#hiddenText1 .v_message_item_msg_a").html(item.relation);
        }else{
          if(data.photo != undefined && data.photo != ''){
            $("#hiddenText1 .v_message_item_img_only").hide();
            $("#hiddenText1 .v_message_item_img").show();
            $("#hiddenText1 .v_message_item_img").attr("src", item.avatar);
            $("#hiddenText1 .v_message_item_msg_a").hide();
          }else{
            $("#hiddenText1 .v_message_item_img_only").show();
            $("#hiddenText1 .v_message_item_img_only").html(item.userName.substring(0,1));
            $("#hiddenText1 .v_message_item_img").hide();
            $("#hiddenText1 .v_message_item_msg_a").hide();
          }
        }
        $("#hiddenText1 .v_message_item_name").html(item.userName);
        $("#hiddenText1 .v_message_item_msg").html(item.msg);
        var obj1 = $($("#hiddenText1").html());
        obj1.attr("class", "spanText");
        let a = parseFloat($("#hiddenText1").css("width"));
        obj1.css("right", a * -1);
        obj1.css("width", a);
        $("#divText1").append(obj1);
        this.startText(obj1);
        this.isTop = false;
      } else {
        if(data.type == 1){
          $("#hiddenText2 .v_message_item_img_only").show();
          $("#hiddenText2 .v_message_item_img_only").html(item.userName.substring(0,1));
          $("#hiddenText2 .v_message_item_img").hide();
          $("#hiddenText2 .v_message_item_msg_a").show();
          $("#hiddenText2 .v_message_item_msg_a").html(item.relation);
        }else{
          if(data.photo != undefined && data.photo != ''){
            $("#hiddenText2 .v_message_item_img_only").hide();
            $("#hiddenText2 .v_message_item_img").show();
            $("#hiddenText2 .v_message_item_img").attr("src", item.avatar);
            $("#hiddenText2 .v_message_item_msg_a").hide();
          }else{
            $("#hiddenText2 .v_message_item_img_only").show();
            $("#hiddenText2 .v_message_item_img_only").html(item.userName.substring(0,1));
            $("#hiddenText2 .v_message_item_img").hide();
            $("#hiddenText2 .v_message_item_msg_a").hide();
          }
        }
        $("#hiddenText2 .v_message_item_name").html(item.userName);
        $("#hiddenText2 .v_message_item_msg").html(item.msg);
        var obj1 = $($("#hiddenText2").html());
        obj1.attr("class", "spanText");
        let a = parseFloat($("#hiddenText2").css("width"));
        obj1.css("right", a * -1);
        obj1.css("width", a);
        $("#divText2").append(obj1);
        this.startText(obj1);
        this.isTop = true;
      }
    },
    startText(obj) {
      
      if (obj.prev().length == 0 || parseFloat(obj.prev().css("right")) > 100) {
        var right = parseFloat(obj.css("right"));
        obj.css("right", right + 1);
        if (right < this.$refs.barragesItem.offsetWidth) {
          setTimeout(() => {
            this.startText(obj);
          }, 10);
        } else {
          obj.remove();
        }
      } else {
        setTimeout(() => {
          this.startText(obj);
        }, 500);
      }
    },

    websocketsend(Data) {
      //数据发送
      //this.websock.send(Data)
    },

    websocketclose(e) {
      //关闭
      console.log("断开连接", e);
      if (this.isClose) {
        return;
      }
      setTimeout(() => {
        if (this.isClose) {
          return;
        }
        this.initWebSocket();
      }, 5000);
    },

    closePage() {
      this.bulletScreenTimer && clearTimeout(this.bulletScreenTimer);
      screenfull.exit();
      this.$router.back(-1);
    },

    toSound() {
      if (this.isSound) {
        this.$refs.video.muted = true;
        this.$refs.audio.pause();
      } else {
        this.$refs.video.muted = false;
        this.$refs.audio.play();
      }
      this.isSound = !this.isSound;
    },

    toCut() {
      if (this.wangPic <= 0) {
        return;
      }
      this.wangPic = this.wangPic - 1;
      this.paddingW = (100 - this.wangPic) * 0.1;
      this.paddingH =
        ((100 - this.wangPic) / this.screenWidth) * this.screenHeight * 0.1;
      this.wangSize =
        (this.screenWidth - (100 - this.wangPic)).toFixed(2) / this.screenWidth;
      window.localStorage.setItem("wangPic", this.wangPic);
    },

    toAdd() {
      if (this.wangPic >= 100) {
        return;
      }
      this.wangPic = this.wangPic + 1;
      this.paddingW = (100 - this.wangPic) * 0.1;
      this.paddingH =
        ((100 - this.wangPic) / this.screenWidth) * this.screenHeight * 0.1;
      this.wangSize =
        (this.screenWidth - (100 - this.wangPic)).toFixed(2) / this.screenWidth;
      window.localStorage.setItem("wangPic", this.wangPic);
    },

    destroyed() {
      window.removeEventListener("popstate", this.onClickLeft, false);
      window.removeEventListener("keydown", this.KeyDown, false);
    },

    mouseMove() {
      var div = document.getElementById("con_lf_top_div");
      div.style.cursor = "auto";
      if (this.moveTimeOut != null) {
        clearTimeout(this.moveTimeOut);
      }
      this.moveTimeOut = setTimeout(() => {
        div.style.cursor = "none";
      }, 5000);
    },

    toAll() {
      if (this.isAll) {
        this.isAll = false;
        screenfull.exit();
      } else {
        this.isAll = true;
        screenfull.toggle();
      }
    },
    //获取历史弹幕最新100条
    findBulletScreenByDmId() {
      let data = {};
      data = {
        data: this.$route.query.id,
        pageInfo: {
          page: 1,
          size: 200,
          total: 0,
        },
      };
      let headers = {
        "Content-Type": "application/json;charset=UTF-8;",
      };
      let request = new Request("/bygDeadManV2/findBulletScreenByDmId", {
        method: "POST",
        credentials: "include",
        headers: headers,
        body: JSON.stringify(data),
      });
      fetch(request)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          if (res.status == 1000) {
            this.findBulletScreenByDmIdTimer(res.data, 0);
          }
        })
        .catch((err) => {
          this.findBulletScreenByDmIdTimer([], 0);
          console.log(err);
        });
    },
    //弹幕循环显示
    findBulletScreenByDmIdTimer(rows, index){
      if(rows.length == 0){
        this.bulletScreenTimer = setTimeout(() => {
          this.findBulletScreenByDmId();
        }, this.bulletScreenTimerMillisecond);
      }else if(rows.length > index){
        let isAppend = false;
        let right = 0;
        if(this.isTop){
          right = parseFloat($("#divText1 .spanText:last-child").css("right"));
          if(isNaN(right) || right > 0){
            isAppend = true;
          }
        }else{
          right = parseFloat($("#divText2 .spanText:last-child").css("right"));
          if(isNaN(right) || right > 0){
            isAppend = true;
          }
        }
        if(isAppend){
          this.appendDivText(rows[index]);
          this.bulletScreenTimer = setTimeout(() => {
            this.findBulletScreenByDmIdTimer(rows, index + 1);
          }, this.bulletScreenTimerMillisecond);
        }else{
          this.bulletScreenTimer = setTimeout(() => {
            this.findBulletScreenByDmIdTimer(rows, index);
          }, 1000);
        }
      }else{
        this.findBulletScreenByDmId();
      }
    },
  },
};
</script>

<style>
.v_all_background {
  width: 100%;
  height: 100%;
  background: #000000;
  box-sizing: border-box !important;
  position: relative;
  overflow: hidden;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */
  -khtml-user-select: none; /* Konqueror */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
  not supported by any browser */
}

.v_video_all {
  width: 100%;
  height: 100%;
  position:relative;
}

.v_video_all .online_video_bg {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;

}
.v_video_all .online_video_bg .photo {
  width:18.00%;
  height:43.05%;
  position: absolute;
  left: 41.04%;
  top:18.26%;
}
.v_video_all .online_video_bg .border {
  width:52.50%;
  height:74.44%;
  position: absolute;
  left: 23.75%;
  top:4.62%;
}
.v_video_all .online_video_bg .name {
  width:100%;
  height:15.27%;
  position: absolute;
  left: 0;
  top:78.00%;
}
.v_video {
  height: 100%;
  object-fit: fill;
  background-color: #000000;
}

.v_hidden {
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  opacity: 0;
}

.v_bottom_none {
  overflow-x: auto;
  overflow-y: hidden;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}

.v_bottom_none_middle {
  display: flex;
  height: 160px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  min-width: 1920px;
}

.v_bottom_none_another {
  height: 160px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  min-width: 1920px;
}

.iv_close {
  width: 49px;
  height: 48px;
  margin-right: 80px;
  cursor: pointer;
}

.v_bottom_left {
  height: 160px;
  line-height: 160px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.v_bottom_text {
  font-size: 40px;
  font-weight: 500;
  color: #ffffff;
  flex-shrink: 0;
}

.iv_message {
  width: 120px;
  height: 50px;
  cursor: pointer;
}

.v_chocie_all {
  width: 140px;
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  background: linear-gradient(180deg, #f9c400 0%, #f19100 100%);
  cursor: pointer;
  flex-shrink: 0;

}
.v_chocie_video_online {
  width: 140px;
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  margin-left: 20px;
  background: linear-gradient(180deg, #67BCFF 0%, #0691FF 100%);
  cursor: pointer;
  flex-shrink: 0;
}

.iv_button {
  width: 30px;
  height: 30px;
}

.v_choice_text {
  font-size: 30px;
  font-weight: 400;
  color: #ffffff;
  margin-left: 10px;
}
.v_choice_text_online {
  font-size: 30px;
  font-weight: 400;
  color: #ffffff;
}

.v_input {
  display: none;
}

.v_bottom_click_line {
  position: fixed;
  bottom: 0;
  height: 30px;
  left: 0;
  right: 0;
  background: #00000000;
}

.v_bottom_ani {
  /* width: 100%; */
  min-height: 230px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  overflow: auto;
}

.progress {
  padding-left: 60px;
  padding-right: 180px;
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 1920px;
  box-sizing: border-box;
}

.iv_sound {
  margin-left: 20px;
  width: 42px;
  height: 32px;
  cursor: pointer;
}

.progress_button {
  width: 20px;
  height: 30px;
}

.progress .el-slider {
  margin-left: 20px;
  flex-grow: 2;
}

.progress .el-slider__bar {
  background-color: #ff9e00;
}

.progress .el-slider__button {
  border: 0;
  background-color: #ff9e00;
}

.progress_item {
  width: 640px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.progress_item_text {
  color: #ff9e00;
  width: 35px;
  height: 35px;
  cursor: pointer;
}

.progress_item_slider {
  flex-grow: 2;
  margin-left: 10px;
  margin-right: 10px;
}

.progress_item_slider .el-slider__bar {
  background-color: #ff9e00;
}

.progress_item_slider .el-slider__button {
  border: 0;
  background-color: #ff9e00;
}
</style>

<style lang="stylus">
.barrages-drop {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;

  .baberrage-lane {
    .blue {
      margin-top: 10px;
      // border-radius: 100px;
      // background: #e6ff75;
    }

    .green {
      margin-top: 80px;
      // border-radius: 100px;
      // background: #75ffcd;
    }

    .red .normal {
      margin-top: 150px;
      border-radius: 100px;
      background: #e68fba;
      color: #fff;
    }
  }

  .barrages_item {
    width: 100%;
    height: 80px;
    line-height: 80px;
    position: relative;
  }

  .barrages_text {
    // display: inline-block;
  }
}

.spanText {
  position: absolute;
  right: 0;
  top: 0;
  height: 80px;
  line-height: 80px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.barrages_text_item {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.v_message_item {
  display: inline;
  // flex-direction: row;
  // align-items: center;
  color: #fff;
}

.v_message_item_img {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  margin-left: 10px;
  margin-right: 10px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.5);
  // object-fit:none;
  // object-fit: cover;
  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor;
}

.v_message_item_img_only {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-left: 10px;
  margin-right: 10px;
  background: #FFFFFF;
  border: 1px solid #949494;
  font-weight: 400;
  color: #000000;
  text-align: center;
  line-height: 40px;
  font-size:22px;
  text-shadow: 0px 1px 2px rgba(0,0,0,0.5);
  box-shadow: 0px 1px 2px 0px rgba(0,0,0,0.5);
}

.v_message_item_name {
  font-size: 38px;
  font-weight: 500;
  color: #FFA600;
  text-shadow: 0px 1px 2px rgba(195, 121, 0, 0.5);
  line-height: 80px;
  // margin-left:10px;
  margin-right:10px;
}

.v_message_item_relation {
  font-size: 20px;
  font-weight: 400;
  height:30px;
  line-height: 30px;
  border: 1px solid #949494;
  background: #F7F8F9;
  border-radius: 5px;
  padding-left:10px;
  padding-right:10px;
  color: #000000;
  margin-left:10px;
  margin-right:10px;
}

.v_message_item_msg {
  font-size: 36px;
  font-weight: 600;
  color: #FFFFFF;
  text-shadow: 0px 1px 2px rgba(94, 94, 94, 0.5);
  -webkit-text-stroke: 1.5px #000000;
  text-stroke: 1.5px #000000;
  line-height: 80px;
  color: #fff;
}

.v_message_item_msg_a{
  /* font-size: 36px;
  font-weight: 500;
  color: #FFFFFF;
  text-shadow: 0px 1px 2px rgba(94, 94, 94, 0.5);
  -webkit-text-stroke: 1px #5F5F5F;
  text-stroke: 1px #5F5F5F;
  line-height: 80px;
  color: #fff; */
  
  font-size: 36px;
  font-weight: 600;
  color: #FFFFFF;
  text-shadow: 0px 1px 2px rgba(94, 94, 94, 0.5);
  -webkit-text-stroke: 1.5px #000000;
  text-stroke: 1.5px #000000;
  line-height: 80px;
  color: #fff;
  margin-right:10px;
}

.iv_move {
  height: 20px;
  width: 20px;
  position: absolute;
  top: 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/Video/Video.vue